<script setup lang="ts">
const props = defineProps<{ title: string }>();
const modalsStore = useModalsStore();
const stepList = [
    {
        img: '/img/new/launch-steps/consulting-01.webp',
        title: 'مشاوره و انتخاب شماره',
        description: 'برای بررسی شماره‌های موجود، با کارشناسان ما تماس بگیرید.'
    },
    {
        img: '/img/new/launch-steps/send-docs.webp',
        title: 'ارسال مدارک',
        description: 'مدارک حقوقی شرکت را به همراه نامه‌ی درخواست خط، به مخابرات ارسال کنید.'
    },
    {
        img: '/img/new/launch-steps/check-and-confirm-01.webp',
        title: 'بررسی و تأیید مخابرات',
        description: 'مدارک توسط مخابرات بررسی و تأیید می‌شود.'
    },
    {
        img: '/img/new/launch-steps/done.webp',
        title: 'تحویل و فعال‌سازی',
        description: 'خط فعال شده و آماده استفاده است.'
    },
];

function handleOpenModal() {
    modalsStore.openModal('CTA');
};
</script>

<template>
    <div class="bg-grad section-py">
        <div class="gridClass py-16">
            <h2>{{ props.title }}</h2>
            <div class="flex flex-col lg:flex-row items-center lg:items-start mt-15">
                <div 
                    v-for="step, index in stepList"
                    :key="step.title"
                    class="relative w-82.5 flex lg:flex-col gap-12 lg:gap-4 items-center py-8 lg:py-16"
                >
                    <div class="flex-center">
                        <span class="step-ind">{{ index + 1 }}</span>
                        <div v-if="index !== 0" class="dashed-line right" />
                        <NuxtImg 
                            :src="step.img"
                            :alt="step.img"
                            width="80"
                            class="relative z-2 min-w-14 w-14 lg:w-20 bg-white"
                            loading="lazy"
                            data-aos="flip-right" 
                            data-aos-duration="1000"
                            :data-aos-delay="index * 300"
                        />
                        <div v-if="index !== stepList.length - 1" class="dashed-line left" />
                    </div>
                    <div 
                        class="flex flex-col lg:items-center relative z-1 pr-2 lg:pr-0"
                        data-aos="flip-right" 
                        data-aos-duration="1000"
                        :data-aos-delay="index * 300"
                    >
                        <h3 class="mb-2">{{ step.title }}</h3>
                        <p class="max-w-65 text-gray-400 text-body2 lg:text-center">{{ step.description }}</p>
                    </div>
                </div>
            </div>
            <Button
                :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                class="mx-auto"
                @click="handleOpenModal"
            >
                شروع فرآیند ثبت‌نام
            </Button>
        </div>
    </div>
</template>

<style scoped>
@reference "~/assets/css/main.css";
.bg-grad {
  background: linear-gradient(
    to bottom, 
    var(--color-secondary-200), 
    white 15%, 
    white 85%, 
    var(--color-secondary-200)
  );
}

.step-ind {
    text-shadow:
        -1px -1px 0 var(--color-secondary-200),
        1px -1px 0 var(--color-secondary-200),
        -1px  1px 0 var(--color-secondary-200),
        1px  1px 0 var(--color-secondary-200);
    @apply
    absolute right-15 bg-clip-text text-[5rem] text-white font-bold select-none
    lg:right-0 lg:text-[10rem]
}
.dashed-line {
    @apply
    absolute w-0 h-1/2 border-r-[3px] border-dashed z-0 border-gray-400
    lg:w-1/2 lg:h-0 lg:border-r-0 lg:border-t-[3px]
}
.dashed-line::before {
    @apply
    content-[''] absolute w-0.75 h-full top-0 -right-0.75 bg-linear-to-b
    lg:bg-linear-to-r lg:w-full lg:h-0.75 lg:-top-0.75 lg:left-0
}
.dashed-line.left::before {
    @apply
    from-white to-transparent
    lg:from-transparent lg:to-white
}
.dashed-line.right::before {
    @apply
    from-transparent to-white
    lg:from-white lg:to-transparent
}
.dashed-line.left {
    @apply
    right-7 bottom-[1.5px]
    lg:left-[1.5px] lg:right-auto lg:bottom-auto
}
.dashed-line.right {
    @apply
    right-7 top-[1.5px]
    lg:right-[1.5px] lg:top-auto
}
</style>